// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3q0AQ","imageUploader":"EGiftCard_imageUploader__1je9T"};